import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import FilesUploader from './files-uploader';

const FilesUploaderWrapper = ({ name, options }) => (
  <Field name={name} options={options} component={FilesUploader} />
);

export default FilesUploaderWrapper;

FilesUploaderWrapper.propTypes = {
  name: PropTypes.string,
  options: PropTypes.object,
};
